import React from 'react';

interface CottonBudProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
  /** Whether the cotton tip should look wet (slightly darker, glossier). */
  wet?: boolean;
}

/**
 * Cotton bud (cotton swab) — a slender wooden stick with a white fluffy
 * tip on each end. Used at the end of the CuO reduction experiment to
 * dab away condensed water droplets from the exit end of the glass tube.
 */
export function CottonBud({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  wet = false,
}: CottonBudProps) {
  const stickLength = 0.075;
  const stickRadius = 0.0018;
  const tipRadius = 0.006;
  const tipColor = wet ? '#dcdce0' : '#fafafa';

  return (
    <group position={position} rotation={rotation} scale={scale}>
      {/* Stick */}
      <mesh castShadow>
        <cylinderGeometry args={[stickRadius, stickRadius, stickLength, 12]} />
        <meshStandardMaterial color="#d8c899" roughness={0.85} />
      </mesh>
      {/* Fluffy tip — top */}
      <mesh position={[0, stickLength / 2 + tipRadius - 0.001, 0]} castShadow>
        <sphereGeometry args={[tipRadius, 14, 14]} />
        <meshStandardMaterial color={tipColor} roughness={wet ? 0.5 : 0.95} />
      </mesh>
      {/* Fluffy tip — bottom */}
      <mesh position={[0, -stickLength / 2 - tipRadius + 0.001, 0]} castShadow>
        <sphereGeometry args={[tipRadius, 14, 14]} />
        <meshStandardMaterial color={tipColor} roughness={wet ? 0.5 : 0.95} />
      </mesh>
    </group>
  );
}

export default CottonBud;
